import { render, staticRenderFns } from "./TransitionBlock.vue?vue&type=template&id=5ec67400&scoped=true&lang=pug&"
import script from "./TransitionBlock.vue?vue&type=script&lang=js&"
export * from "./TransitionBlock.vue?vue&type=script&lang=js&"
import style0 from "./TransitionBlock.vue?vue&type=style&index=0&id=5ec67400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec67400",
  null
  
)

export default component.exports